export default {
  ESAD_DEFAULT: 1000,
  ESAD_SCATTER: 3000
}

